module.exports = __webpack_public_path__ + "static/media/no-results-illustration.937e22ae.svg";